import {baseRequest} from './base';

//获取banner列表
function getBannerList(params){
  let tempUrl = '/api/pcWeb/banner';
  return baseRequest(tempUrl,'get',params);
}

//新增banner
function add(params){
  let tempUrl = '/api/pcWeb/banner';
  return baseRequest(tempUrl,'post',params);
}

//修改banner
function edit(params){
  let tempUrl = '/api/pcWeb/banner';
  return baseRequest(tempUrl,'post',params);
}

//删除banner
function del(params){
  let tempUrl = '/api/pcWeb/banner/deleteBanner/'+params.id;
  return baseRequest(tempUrl,'delete');
}

//上架
function up(params){
  let tempUrl = '/api/pcWeb/banner/upOrDownBanner';
  return baseRequest(tempUrl,'put',params);
}

//下架
function down(params){
  let tempUrl = '/api/pcWeb/banner/upOrDownBanner';
  return baseRequest(tempUrl,'put',params);
}

//详情
function detail(params){
  let tempUrl = '/api/pcWeb/banner/'+params.id;
  return baseRequest(tempUrl,'get');
}

//搜索学校
function searchSchool(params){
  let tempUrl = '/api/pcWeb/teaSchool/selectSchoolOfBureau';
  return baseRequest(tempUrl,'get',params);
}

export default {
  getBannerList,add,edit,del,up,down,detail,searchSchool
}
